import logo_seibii_with_words from '@/assets/images/logos/seibii_with_words.svg';
import guidePdf from '@/assets/files/guide/guide_ver5.pdf';
import { useDirectScheduleAdjustmentQuery } from '@/hooks/apis';
import { bem } from '@/utilities';
import React from 'react';
import { Link, useParams } from 'react-router-dom';

export const Header: React.FC = () => {
  const { token } = useParams();
  const directScheduleAdjustmentQuery = useDirectScheduleAdjustmentQuery(token);

  return (
    <header className='header-body'>
      <p className={bem('header-body', 'name')}>{directScheduleAdjustmentQuery.data?.title || ''}</p>
      <nav className={bem('header-body', 'navigation')}>
        <Link to={`/schedule_adjustments/${token}`} className={bem('header-body', 'logo')}>
          <img className={bem('header-body', 'logo-image')} src={logo_seibii_with_words} />
          <p className={bem('header-body', 'logo-text')}>{directScheduleAdjustmentQuery.data?.title || ''}</p>
        </Link>
        <div className={bem('header-body', 'links')}>
          <a href={guidePdf} className={bem('header-body', 'help-link')} target='_blank' rel='noreferrer'>
            よくある質問
          </a>
          <Link to={`/schedule_adjustments/${token}`} className={bem('header-body', 'schedule-link')}>
            日程調整
          </Link>
          <Link to={`/orders/${token}`} className={bem('header-body', 'work-link')}>
            予約履歴
          </Link>
        </div>
      </nav>
    </header>
  );
};
